<script lang="ts" setup>
import TgTooltip from "@/abc-dsk/components/Tooltip/TgTooltip.vue";
import { useArticleFont } from "@/common/composables/use-article-font.composable";
import type { ArabicLemma } from "@/components/article/arabic/article";

defineProps<{
  lemma: ArabicLemma;
}>();

const { arabicArticleFontClass } = useArticleFont();
</script>

<template>
  <span
    v-if="lemma.root"
    class="article-content__text article-content__text--light article-content__text--italic flex-lg-grow-1 text-lg-left"
  >
    (<span class="pr-2" lang="da">{{ lemma.form }}</span
    ><span
      class="pr-2 article-content__text article-content__text--primary"
      :class="arabicArticleFontClass"
      lang="ar"
      dir="rtl"
      >{{ lemma.root }}</span
    ><span lang="da">rod</span>)
  </span>

  <span
    v-for="(conjugation, conjugationIndex) in lemma.conjugations"
    :key="conjugationIndex"
    class="article-content__text article-content__text--secondary article-content__text--italic"
  >
    (<span
      class="left-parenthesis-padding pr-2"
      :class="arabicArticleFontClass"
      lang="ar"
      dir="rtl"
      >{{ conjugation.text }}</span
    >
    <TgTooltip
      :text="conjugation.getType()"
      class="article-content__text--secondary-with-tooltip"
      >{{ conjugation.getAbbreviatedType() }}</TgTooltip
    >)
  </span>

  <span
    v-if="lemma.wordclass.short"
    class="article-content__text article-content__text--light article-content__text--italic article-content__text--light-with-tooltip"
  >
    <TgTooltip :text="`${lemma.wordclass.latin} (${lemma.wordclass.danish})`">
      {{ lemma.wordclass.short }}
    </TgTooltip>
  </span>

  <span v-if="lemma.preposition" class="article-content__text">
    <span class="text-preposition" :class="arabicArticleFontClass" lang="ar" dir="rtl">{{
      lemma.preposition
    }}</span>
  </span>

  <span class="article-content__text article-content__text--primary">
    <TgTooltip
      v-if="lemma.word"
      :text="lemma.pronunciation"
      class="article-content__text--with-tooltip"
    >
      <span
        class="article-content__text article-content__text--primary article-content__text--prominent"
        :class="arabicArticleFontClass"
        lang="ar"
        dir="rtl"
        >{{ lemma.word }}</span
      >
    </TgTooltip>
    <span v-else>~</span>
  </span>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.left-parenthesis-padding {
  padding-left: 2px;
}

.text-preposition {
  color: rgb(@theme-colors[@grey][base]);
}
</style>
